import { RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

export const extranet: RouteObject[] = [
  {
    path: ROUTES.extranet.banners,
    lazy: async () => {
      const { ExtranetBannersPage } = await import('../../pages/extranet');

      return { Component: ExtranetBannersPage };
    },
  },
  {
    path: ROUTES.extranet.staff,
    lazy: async () => {
      const { ExtranetStaffPage } = await import('../../pages/extranet');

      return { Component: ExtranetStaffPage };
    },
  },
  {
    path: ROUTES.extranet.partners.root,
    lazy: async () => {
      const { ExtranetPartnersPage } = await import('../../pages/extranet');

      return { Component: ExtranetPartnersPage };
    },
  },
  {
    path: ROUTES.extranet.partners.form,
    lazy: async () => {
      const { ExtranetPartnersFormPage } = await import('../../pages/extranet');

      return { Component: ExtranetPartnersFormPage };
    },
  },
  {
    path: ROUTES.extranet.tools.root,
    lazy: async () => {
      const { ExtranetPartnersPage } = await import('../../pages/extranet');

      return { Component: ExtranetPartnersPage };
    },
  },
  {
    path: ROUTES.extranet.tools.form,
    lazy: async () => {
      const { ExtranetPartnersFormPage } = await import('../../pages/extranet');

      return { Component: ExtranetPartnersFormPage };
    },
  },
  {
    path: ROUTES.extranet.events.root,
    lazy: async () => {
      const { ExtranetEventsPage } = await import('../../pages/extranet');

      return { Component: ExtranetEventsPage };
    },
  },
  {
    path: ROUTES.extranet.events.form,
    lazy: async () => {
      const { ExtranetEventsFormPage } = await import('../../pages/extranet');

      return { Component: ExtranetEventsFormPage };
    },
  },
  {
    path: ROUTES.extranet.actus.root,
    lazy: async () => {
      const { ExtranetActusPage } = await import('../../pages/extranet');

      return { Component: ExtranetActusPage };
    },
  },
  {
    path: ROUTES.extranet.actus.form,
    lazy: async () => {
      const { ExtranetActusFormPage } = await import('../../pages/extranet');

      return { Component: ExtranetActusFormPage };
    },
  },
  {
    path: ROUTES.extranet.newsletters,
    lazy: async () => {
      const { ExtranetNewslettersPage } = await import('../../pages/extranet');

      return { Component: ExtranetNewslettersPage };
    },
  },
  {
    path: ROUTES.extranet.agreements.mandatory.root,
    lazy: async () => {
      const { ExtranetAgreementsPage } = await import('../../pages/extranet');

      return { Component: ExtranetAgreementsPage };
    },
  },
  {
    path: ROUTES.extranet.agreements.mandatory.form,
    lazy: async () => {
      const { ExtranetAgreementsFormPage } =
        await import('../../pages/extranet');

      return { Component: ExtranetAgreementsFormPage };
    },
  },
  {
    path: ROUTES.extranet.agreements.priority.root,
    lazy: async () => {
      const { ExtranetAgreementsPage } = await import('../../pages/extranet');

      return { Component: ExtranetAgreementsPage };
    },
  },
  {
    path: ROUTES.extranet.agreements.priority.form,
    lazy: async () => {
      const { ExtranetAgreementsFormPage } =
        await import('../../pages/extranet');

      return { Component: ExtranetAgreementsFormPage };
    },
  },
  {
    path: ROUTES.extranet.agreements.recommended.root,
    lazy: async () => {
      const { ExtranetAgreementsPage } = await import('../../pages/extranet');

      return { Component: ExtranetAgreementsPage };
    },
  },
  {
    path: ROUTES.extranet.agreements.recommended.form,
    lazy: async () => {
      const { ExtranetAgreementsFormPage } =
        await import('../../pages/extranet');

      return { Component: ExtranetAgreementsFormPage };
    },
  },
  {
    path: ROUTES.extranet.actusLabo.root,
    lazy: async () => {
      const { ExtranetActusLaboPage } = await import('../../pages/extranet');

      return { Component: ExtranetActusLaboPage };
    },
  },
  {
    path: ROUTES.extranet.actusLabo.form,
    lazy: async () => {
      const { ExtranetActusLaboFormPage } =
        await import('../../pages/extranet');

      return { Component: ExtranetActusLaboFormPage };
    },
  },
  {
    path: ROUTES.extranet.directory.root,
    lazy: async () => {
      const { ExtranetDirectoryPage } = await import('../../pages/extranet');

      return { Component: ExtranetDirectoryPage };
    },
  },
  {
    path: ROUTES.extranet.directory.form,
    lazy: async () => {
      const { ExtranetDirectoryFormPage } =
        await import('../../pages/extranet');

      return { Component: ExtranetDirectoryFormPage };
    },
  },
  {
    path: ROUTES.extranet.faq,
    lazy: async () => {
      const { ExtranetFaqPage } = await import('../../pages/extranet');

      return { Component: ExtranetFaqPage };
    },
  },
  {
    path: ROUTES.extranet.medias,
    lazy: async () => {
      const { ExtranetMediasPage } = await import('../../pages/extranet');

      return { Component: ExtranetMediasPage };
    },
  },
  {
    path: ROUTES.extranet.tasks.root,
    lazy: async () => {
      const { Tasks } = await import('../../pages/extranet');

      return { Component: Tasks };
    },
  },
  {
    path: ROUTES.extranet.tasks.form,
    lazy: async () => {
      const { TaskFormPage } = await import('../../pages/extranet');

      return { Component: TaskFormPage };
    },
  },
  {
    path: ROUTES.extranet.tasks.detail,
    lazy: async () => {
      const { ResumeTask } = await import('../../pages/extranet');

      return { Component: ResumeTask };
    },
  },
  {
    path: ROUTES.extranet.settings,
    lazy: async () => {
      const { ExtranetSettingsPage } = await import('../../pages/extranet');

      return { Component: ExtranetSettingsPage };
    },
  },
];
